export default __webpack_public_path__ + "static/media/loading-screen.4bb62890.svg";